<template>
  <v-container fluid grid-list-md>
    <v-data-iterator
      :items="premixes"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :no-data-text="'Please add premixes'"
      content-tag="v-layout"
      row
      wrap
    >
      <template v-slot:item="props">
        <v-flex xs12 sm6 md4>
          <premixin
            :premixin="props.item"
            :edit="editLocal"
            @editPreMixin="showEditPreMixesPopup"
          />
        </v-flex>
      </template>

      <template v-if="permissions.EDIT" v-slot:actions-append>
        <template v-if="editLocal">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                small
                color="success"
                :disabled="isResetPreMixes || isSendingPreMixes"
                v-on="on"
                @click="showNewPreMixesPopup"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>New premix</span>
          </v-tooltip>
          <v-btn
            @click="resetPreMixes"
            :loading="isResetPreMixes"
            :disabled="isResetPreMixes || isSendingPreMixes"
            flat
            color="warning"
          >
            Reset
          </v-btn>
          <v-btn
            :loading="isSendingPreMixes"
            :disabled="isSendingPreMixes || isResetPreMixes"
            @click="savePreMixes"
            color="success"
          >
            Save
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            :loading="isSendingPreMixes"
            :disabled="isSendingPreMixes || isResetPreMixes"
            @click="editPreMixins"
            color="warning"
          >
            Edit
          </v-btn>
        </template>
      </template>
    </v-data-iterator>

    <template v-if="permissions.EDIT">
      <new-pre-mixin-popup
        :dialog.sync="newPreMixesPopupStatus"
        :ingredientsGroups="ingredientsGroups"
        @newPreMixin="addNewPreMixes"
      />

      <edit-pre-mixin-popup
        :dialog.sync="editPreMixesPopupStatus"
        :premixin="selectedPreMixin"
        :ingredientsGroups="ingredientsGroups"
        @savePreMixin="updatePreMixin"
        v-if="selectedPreMixin"
      />
    </template>
  </v-container>
</template>

<script>
import Premixes from '@/orm/models/Premixes';
import Mixins from '@/orm/models/Mixins';
import MixRecipes from '@/orm/models/MixRecipes';
import MixingModule from '@/orm/models/MixingModule';
import MixinComponents from '@/orm/models/MixinComponents';
import IngredientGroups from '@/orm/models/IngredientGroups';
import CustomIngredients from '@/orm/models/CustomIngredients';

export default {
  name: 'premixes',
  props: {
    edit: {
      type: Boolean,
      default: () => false,
    },
    permissions: Object,
  },
  data() {
    return {
      rowsPerPageItems: [
        3,
        { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 },
      ],
      pagination: {
        rowsPerPage: -1,
      },
      isResetPreMixes: false,
      isSendingPreMixes: false,
      newPreMixesPopupStatus: false,
      editPreMixesPopupStatus: false,
      selectedPreMixin: null,
    };
  },
  computed: {
    editLocal: {
      get() {
        return this.edit;
      },
      set(val) {
        this.$emit('update:edit', val);
      },
    },
    premixes() {
      return Premixes.all();
    },
    ingredientsGroups() {
      return IngredientGroups.all();
    },
  },
  methods: {
    async updatePreMixin({ premixin }) {
      const premix = JSON.parse(JSON.stringify(premixin));
      await Premixes.insertOrUpdate({ data: premix });
      this.selectedPreMixin = new Premixes();
    },
    editPreMixins() {
      this.editLocal = true;
    },
    showNewPreMixesPopup() {
      this.newPreMixesPopupStatus = true;
    },
    showEditPreMixesPopup(id) {
      this.selectedPreMixin = Premixes.find(id).$toJson();
      this.editPreMixesPopupStatus = true;
    },
    async addNewPreMixes({ premixin }) {
      await Premixes.insert({ data: premixin });
    },
    async resetPreMixes() {
      try {
        this.isResetPreMixes = true;
        const { params } = this.$route;
        const { mixes } = await MixingModule.$get({ params });
        await Mixins.create({ data: mixes.items || [] });
        const { recipes, premixes, custom_ingredients } = await MixinComponents.$get({ params });
        await IngredientGroups.$fetch();
        await CustomIngredients.create({ data: custom_ingredients });
        await Premixes.create({ data: premixes });
        await MixRecipes.create({ data: recipes });
      } finally {
        this.isResetPreMixes = false;
        this.editLocal = false;
      }
    },
    async savePreMixes() {
      try {
        this.isSendingPreMixes = true;
        const premixesLocal = this.premixes;
        const { params } = this.$route;
        const { mixes } = await MixingModule.$create({
          params,
          data: {
            premixes: {
              items: premixesLocal,
            },
          },
        });
        await Mixins.create({ data: mixes.items || [] });
        const { recipes, premixes, custom_ingredients } = await MixinComponents.$get({ params });
        await IngredientGroups.$fetch();
        await CustomIngredients.create({ data: custom_ingredients });
        await Premixes.create({ data: premixes });
        await MixRecipes.create({ data: recipes });
      } finally {
        this.isSendingPreMixes = false;
        this.editLocal = false;
      }
    },
  },
  components: {
    premixin: () => import('./premixin'),
    newPreMixinPopup: () => import('./newPreMixinPopup'),
    editPreMixinPopup: () => import('./editPreMixinPopup'),
  },
};
</script>
